<template>
  <!-- 轮播图 -->
  <div class="block text-center b-hight" m="t-4">
    <!-- <el-carousel ref="carousel" height="25em">
      <el-carousel-item v-for="item in 4" :key="item">
        <h3 class="small justify-center" text="2xl">{{ item }}</h3>
      </el-carousel-item>
    </el-carousel> -->
    <!-- <img src="../assets/leader.png" alt="" style="height: 25em;width: 100%;"> -->
    <h1 class="title">{{ isEnglish ? 'Tailor-made AI implementation for enterprises and industries' : '企业和工业级AI应用服务商' }}</h1>

    <!-- <button class="left" @click="$refs.carousel.prev()"><el-icon><ArrowLeftBold /></el-icon></button>
    <button class="right" @click="$refs.carousel.next()"><el-icon><ArrowRightBold /></el-icon></button> -->
    <div class="banner_btn">
      <button class="demo" @click="goToContact(2)">{{ isEnglish ? 'Eco-cooperation' : '生态合作' }}</button>

      <button class="contact" @click="goToContact(3)">{{ isEnglish ? 'Contact Us' : '联系我们' }}</button>

    </div>

  </div>
  <div v-if="isMobile" class="mobile-tab-bar" :class="{ 'is-fixed': isTabFixed }" ref="tabBarRef">
    <el-tabs v-model="activeTab" @tab-click="handleTabClick">
      <el-tab-pane v-for="tab in orderedTabs" :key="tab.name" :label="tab.label" :name="tab.name"></el-tab-pane>
    </el-tabs>
  </div>
  <div class="section-wrapper">
    <!-- 展示框OUR -->
    <div id="our-solutions" class="our-dis" :style="{ order: sectionOrder.solution || 1 }">
      <h1 style="margin-bottom: 1em;">{{ isEnglish ? 'Our Solutions' : '我们的解决方案' }}</h1>
      <div class="el-hidmobile">
        <el-row :gutter="20">
          <!-- 园区 -->
          <el-col :span="isMobile ? 24 : 12" v-for="(item, index) in datalist" :key="item.id">
            <div class="el-box" v-if="index === 0" @mouseenter="isbutton(index)" @mouseleave="unbutton(index)"
              @click="goto_methods(item.id)">
              <div class="grid-content ep-bg-purple" style="height:16em">
                <div class="grid-box">
                  <img :src="item.thumbnail" alt="">
                  <div class="box-content">
                    <h3>{{ item.name }}</h3>
                    <p>{{ item.description }}</p>
                    <transition name="fade">
                      <el-button @click="goto_methods(item.id)"
                        v-if="isshowbutton[index]">{{ isEnglish ? 'MORE' : '查看更多' }}</el-button>
                    </transition>
                  </div>
                </div>
              </div>
            </div>
            <!-- 空调 -->
            <div class="el-box" v-else-if="index === 1" @mouseenter="isbutton(index)" @mouseleave="unbutton(index)"
              @click="goto_methods(item.id)">
              <div class="grid-content ep-bg-purple grid-all" style="height:16em">
                <div class="grid-left">
                  <img :src="item.thumbnail" alt="">
                </div>
                <div class="grid-right" style="background-color: #222536; color:white">
                  <div class="right-content">
                    <h3>{{ item.name }}</h3>
                    <p>{{ item.description }}</p>
                    <transition name="fade">
                      <el-button @click="goto_methods(item.id)" style="color:white"
                        v-if="isshowbutton[index]">{{ isEnglish ? 'MORE' : '查看更多' }}</el-button>
                    </transition>
                  </div>
                </div>
              </div>
            </div>
            <!-- 水务 -->
            <div class="el-box" v-else-if="index === 2" @mouseenter="isbutton(index)" @mouseleave="unbutton(index)"
              @click="goto_methods(item.id)">
              <div class="grid-content ep-bg-purple grid-all" style="height:16em">
                <div class="grid-left">
                  <img :src="item.thumbnail" alt="">
                </div>
                <div class="grid-right" style="background-color: #fff;">
                  <div class="right-content">
                    <h3>{{ item.name }}</h3>
                    <p>{{ item.description }}</p>
                    <transition name="fade">
                      <el-button @click="goto_methods(item.id)" style="border:1px solid #000;color:#000;"
                        v-if="isshowbutton[index]">{{ isEnglish ? 'MORE' : '查看更多' }}</el-button>
                    </transition>
                  </div>
                </div>
              </div>
            </div>
            <!-- AI -->
            <div class="el-box" v-else-if="index === 3" @mouseenter="isbutton(index)" @mouseleave="unbutton(index)"
              @click="goto_methods(item.id)">
              <div class="grid-content ep-bg-purple" style="height:16em">
                <div class="grid-box">
                  <img :src="item.thumbnail" alt="">
                  <div class="box-content">
                    <h3>{{ item.name }}</h3>
                    <p>{{ item.description }}</p>
                    <transition name="fade">
                      <el-button @click="goto_methods(item.id)"
                        v-if="isshowbutton[index]">{{ isEnglish ? 'MORE' : '查看更多' }}</el-button>
                    </transition>
                  </div>
                </div>
              </div>
            </div>
            <!-- 碳排放 -->
            <div class="el-box" v-else-if="index === 4" @mouseenter="isbutton(index)" @mouseleave="unbutton(index)"
              @click="goto_methods(item.id)">
              <div class="grid-content ep-bg-purple grid-all" style="height:16em">
                <div class="grid-left">
                  <img :src="item.thumbnail" alt="">
                </div>
                <div class="grid-right" style="background-color: #225696; color:white">
                  <div class="right-content">
                    <h3>{{ item.name }}</h3>
                    <p>{{ item.description }}</p>
                    <transition name="fade">
                      <el-button @click="goto_methods(item.id)" style="color:white"
                        v-if="isshowbutton[index]">{{ isEnglish ? 'MORE' : '查看更多' }}</el-button>
                    </transition>
                  </div>
                </div>
              </div>
            </div>
            <!-- 供热 -->
            <div class="el-box" v-else-if="index === 5" @mouseenter="isbutton(index)" @mouseleave="unbutton(index)"
              @click="goto_methods(item.id)">
              <div class="grid-content ep-bg-purple grid-all" style="height:16em">
                <div class="grid-left">
                  <img :src="item.thumbnail" alt="">
                </div>
                <div class="grid-right">
                  <div class="right-content">
                    <h3>{{ item.name }}</h3>
                    <p>{{ item.description }}</p>
                    <transition name="fade">
                      <el-button @click="goto_methods(item.id)" style="border:1px solid #000;color:#000;"
                        v-if="isshowbutton[index]">{{ isEnglish ? 'MORE' : '查看更多' }}</el-button>
                    </transition>
                  </div>
                </div>
              </div>
            </div>
            <!-- 农业 -->
            <div class="el-box" v-else-if="index === 6" @mouseenter="isbutton(index)" @mouseleave="unbutton(index)"
              @click="goto_methods(item.id)">
              <div class="grid-content ep-bg-purple grid-all" style="height:16em">
                <div class="grid-right" style="background-color:#BCC5CC; color:white">
                  <div class="right-content">
                    <h3>{{ item.name }}</h3>
                    <p>{{ item.description }}</p>
                    <transition name="fade">
                      <el-button @click="goto_methods(item.id)" style="background-color: transparent; color:white"
                        v-if="isshowbutton[index]">{{ isEnglish ? 'MORE' : '查看更多' }}</el-button>
                    </transition>
                  </div>
                </div>
                <div class="grid-left">
                  <img :src="item.thumbnail" alt="">
                </div>
              </div>
            </div>
            <!-- 清洁能源 -->
            <div class="el-box" v-else-if="index === 7" @mouseenter="isbutton(index)" @mouseleave="unbutton(index)"
              @click="goto_methods(item.id)">
              <div class="grid-content ep-bg-purple grid-all" style="height:16em">
                <div class="grid-right" style="background-color:#0E45EA; color:white">
                  <div class="right-content">
                    <h3>{{ item.name }}</h3>
                    <p>{{ item.description }}</p>
                    <transition name="fade">
                      <el-button @click="goto_methods(item.id)" style="background-color: transparent; color:white"
                        v-if="isshowbutton[index]">{{ isEnglish ? 'MORE' : '查看更多' }}</el-button>
                    </transition>
                  </div>
                </div>
                <div class="grid-left">
                  <img :src="item.thumbnail" alt="">
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- 展示框PRODUCTS -->
    <div id="products" class="fro-dis" :style="{ order: sectionOrder.product || 2 }">
      <h1 style="margin-bottom: 1em;">{{ isEnglish ? 'Software Products' : '软件产品' }}</h1>
      <div v-if="isMobile" class="fro-hid" style="margin-bottom: 0.25em;">
        <el-row :gutter="20">
          <el-col :span="24" class="col-fro" v-for="(item, index) in pro_data" :key="item.id"
            @click="goto_system(item.id)">
            <div class="grid-content ep-bg-purple" style="height:14em">
              <img :src="item.thumbnail" alt="">
              <div class="el-fro">
                <h3>{{ item.name }}</h3>
                <p style="font-size: 12px;">{{ item.description }}</p>
                <button class="pro-plat" @click.stop="goto_system(item.id)">{{ isEnglish ? 'MORE' : '查看更多' }}</button>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div v-else class="fro-hid">
        <el-row :gutter="20">
          <el-col :span="8" class="col-fro" v-for="(item, index) in pro_data" :key="item.id"
            @mouseenter="isbuttonpPro(index)" @mouseleave="unbuttonpPro(index)" @click="goto_system(item.id)">
            <div class="grid-content ep-bg-purple" style="height:18em">
              <img :src="item.thumbnail" alt="">
              <div class="el-fro">
                <h3>{{ item.name }}</h3>
                <p style="font-size: 12px;">{{ item.description }}</p>
                <transition name="fade">
                  <button class="pro-plat" @click="goto_system(item.id)"
                    v-if="isshowbuttonPro[index]">{{ isEnglish ? 'MORE' : '查看更多' }}</button>
                </transition>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- 展示框PRODUCTHARD -->
    <div id="producthard" class="fro-dis" :style="{ order: sectionOrder.productHard || 3 }">
      <h1 v-if="!isEnglish" style="margin-bottom: 1em;">{{ isEnglish ? 'Hardware Products' : '硬件产品' }}</h1>

      <div v-if="isMobile" class="hardware-group-mobile">
        <div v-for="group in hardwareGroupData" :key="group.typeId" class="hardware-type-group">
          <h2 class="hardware-type-name">{{ group.typeName }}</h2>
          <div class="hardware-grid">
            <div class="hardware-item" v-for="device in group.devices" :key="device.id" @click="goto_device(device.id)">
              <img :src="device.thumbnail" alt="">
              <span class="hardware-item-name">{{ device.name }}</span>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="hardware-group-desktop">
        <div v-for="group in hardwareGroupData" :key="group.typeId" class="hardware-type-group">
          <h2 class="hardware-type-name">{{ group.typeName }}</h2>
          <el-row :gutter="20">
            <el-col :span="8" v-for="device in group.devices" :key="device.id">
              <div class="hardware-item" @click="goto_device(device.id)">
                <img :src="device.thumbnail" alt="">
                <span class="hardware-item-name">{{ device.name }}</span>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <!-- 展示框 分隔栏 -->
    <!--<div class="split-dis">-->
    <!--    <ul>-->
    <!--      <li>-->
    <!--          <img src="../assets/Vector@2x.png" alt=""><br>-->
    <!--          <span>{{isEnglish?'AI':'人工智能'}}</span>-->

    <!--      </li>-->
    <!--      <li>-->
    <!--          <img src="../assets/Vector@3x.png" alt=""><br>-->
    <!--          <span>{{isEnglish?'Big Data':'大数据'}}</span>-->
    <!--      </li>-->
    <!--      <li>-->
    <!--          <img src="../assets/Group_75@4x.png" alt=""><br>-->
    <!--          <span>{{isEnglish?'IOT':'物联网'}}</span>-->
    <!--      </li>-->
    <!--      <li>-->
    <!--          <img src="../assets/Vector@5x .png" alt=""><br>-->
    <!--          <span>{{isEnglish?'Edge Computing':'边缘计算'}}</span>-->
    <!--      </li>-->
    <!--      <li>-->
    <!--          <img src="../assets/Vector@6x.png" alt=""><br>-->
    <!--          <span>{{isEnglish?'Digital Twin':'数字孪生'}}</span>-->
    <!--      </li>-->
    <!--    </ul>-->
    <!--</div>-->
    <!-- 展示框Success -->
    <div id="success" class="suc-dis" style="background-color: #005BAC ; overflow: hidden;"
      :style="{ order: sectionOrder.case || 4 }">
      <h1 style="color: white;">{{ isEnglish ? 'Success Cases' : '成功案例' }}</h1>
      <div v-if="isMobile" class="suc-hid" style="margin-top: 0.25em;">
        <el-row :gutter="20" style="width: 80%;margin: 0.1em auto;">
          <el-col :span="24" v-for="item in suc_data" :key="item.id" style="margin-bottom: 0.1em;"
            @click="goto_case(item.id)">
            <div class="grid-content1 ep-bg-purple" style="background-color: #fff; height:22em">
              <img :src="item.thumbnail" alt="">
              <div class="grid-main">
                <h3 style="font-size: 1.2em; font-weight: 400; margin-top: 0.2em;">{{ item.name }}</h3>
                <p style="font-size: 0.6em; margin-top: 0.2em;">{{ item.description }}</p>
                <button class="grid-btn" style="border:1px solid #000">{{ isEnglish ? 'MORE' : '查看更多' }}</button>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div v-else class="suc-hid" style="margin-top: 2em;">
        <el-row :gutter="20" style="width: 80%;margin: 1em auto;">
          <el-col :span="8" v-for="item in suc_data" :key="item.id" @click="goto_case(item.id)"
            style="cursor: pointer;">
            <div class="grid-content1 ep-bg-purple" style="background-color: #fff; height:22em">
              <img :src="item.thumbnail" alt="">
              <div class="grid-main">
                <h3 style="font-size: 1.2em; font-weight: 400; margin-top: 0.2em;">{{ item.name }}</h3>
                <p style="font-size: 0.6em; margin-top: 0.2em;">{{ item.description }}</p>
                <button class="grid-btn" style="border:1px solid #000"
                  @click="goto_case(item.id)">{{ isEnglish ? 'MORE' : '查看更多' }}</button>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- 展示框News -->
    <div id="news" class="news-dis" v-if="first_data" :style="{ order: sectionOrder.new || 5 }">
      <h1>{{ isEnglish ? 'News' : '新闻' }}</h1>
      <div v-if="isMobile" class="news-grid-container">
        <div class="news-grid">
          <template v-for="(item, index) in new_data">
            <div :key="item.id" class="news-item" v-if="index < 4" @click="goto_newdetail(item.id)">
              <div class="news-meta">
                <div class="news-author">{{ item.name }}</div>
                <div class="news-separator">|</div>
                <div class="news-time">{{
                  splitDate(item.newsTime).year + '-' + splitDate(item.newsTime).month + '-' + splitDate(item.newsTime).day }}
                </div>
              </div>
              <p class="news-description">{{ item.description }}</p>
            </div>
          </template>

          <div class="news-more">
            <button class="news-btn" @click="goto_news">{{ isEnglish ? 'MORE' : '查看更多' }}</button>
          </div>
        </div>
      </div>
      <div v-else class="news-main">
        <div class="news-left">
          <img :src="first_data.thumbnail" alt="">
          <div class="left-con" @click="goto_newdetail(first_data.id)" style="cursor: pointer;"
            v-for="(item, index) in new_data" :key="item.id">
            <p v-if="index === 0">{{ item.description }}</p>
            <div class="bo-time" v-if="index === 0">
              <div class="bo-le">{{ item.name }}</div>
              <div class="bo-mi" style="color: #BEBEBE;">|</div>
              <div class="bo-ri">{{
                splitDate(item.newsTime).year + '-' + splitDate(item.newsTime).month + '-' + splitDate(item.newsTime).day }}
              </div>
            </div>
          </div>
        </div>
        <div class="news-right">
          <ul v-for="(item, index) in new_data">
            <li v-if="index === 1 || index === 2 || index === 3" @click="goto_newdetail(item.id)" style="cursor: pointer;">
              <div class="ri-con">
                <div class="ri-le">{{ item.name }}</div>
                <div class="ri-mi" style="color: #BEBEBE;">|</div>
                <div class="ri-ri">{{
                  splitDate(item.newsTime).year + '-' + splitDate(item.newsTime).month + '-' + splitDate(item.newsTime).day }}
                </div>
              </div>
              <p>{{ item.description }}</p>
            </li>
          </ul>
          <ul>
            <li style="border-bottom: transparent;">
              <button class="new-btn" @click="goto_news">{{ isEnglish ? 'MORE' : '查看更多' }}</button>
            </li>
          </ul>

        </div>
      </div>
    </div>
  </div>
</template>

<script setup name="MainBody">
import { useRouter } from 'vue-router'
import { onMounted, ref, onUnmounted, nextTick, computed } from 'vue';
import { getSolutionList } from '../api/solution'
import { getProductList } from '../api/product'
import { getDeviceTypeList } from '../api/deviceType'
import { getDeviceList } from '../api/device'
import { getCaseList } from '../api/case'
import { getNewsList } from '../api/news'
import { getHomeSectionOrder } from '../api/homeSection'
import { recordVisitor, updateVisitorDuration } from '../api/visitorLog'
const datalist = ref([])
const pro_data = ref([])
const pro_data2 = ref([])
const hardwareGroupData = ref([])
const suc_data = ref([])
const new_data = ref([])
const first_data = ref([])
const sectionOrder = ref({})
const activeTab = ref('sol')
const isshowbutton = ref([false, false, false, false, false, false, false, false])
const isshowbuttonPro = ref([])

const isTabFixed = ref(false)
const tabBarRef = ref(null)
const tabBarOriginalTop = ref(0)

// 判断当前是否为英文环境
const isEnglish = computed(() => {
  return window.location.pathname.startsWith('/en')
})
// 选项卡列表，数据及顺序完全由后端接口返回
const orderedTabs = ref([])

// ScrollSpy: 区块与 Tab 的映射，按 sectionOrder 排序后用于滚动监听
const sectionToTab = [
  { id: 'our-solutions', tab: 'sol', sectionKey: 'solution' },
  { id: 'products', tab: 'pro', sectionKey: 'product' },
  { id: 'producthard', tab: 'producthard', sectionKey: 'productHard' },
  { id: 'success', tab: 'case', sectionKey: 'case' },
  { id: 'news', tab: 'news', sectionKey: 'new' },
]
const orderedSectionToTab = computed(() => {
  return [...sectionToTab].sort((a, b) => {
    return (sectionOrder.value[a.sectionKey] || 99) - (sectionOrder.value[b.sectionKey] || 99)
  })
})
onMounted(() => {
  window.scrollTo(0, 0);
  console.log('页面加载完成');
  checkMobile()
  window.addEventListener('resize', checkMobile)
  window.addEventListener('scroll', handleScroll)
  window.addEventListener('beforeunload', handleBeforeUnload)
  mainrender()
  fetchSectionOrder()
  recordVisit()

  // 获取Tab栏的初始位置
  nextTick(() => {
    if (tabBarRef.value) {
      tabBarOriginalTop.value = tabBarRef.value.offsetTop
    }
  })
})
onUnmounted(() => {
  window.removeEventListener('resize', checkMobile)
  window.removeEventListener('scroll', handleScroll)
  window.removeEventListener('beforeunload', handleBeforeUnload)
  sendStayDuration()
})
const router = useRouter()
const emit = defineEmits(['scroll-to-contact'])
const id = ref(null)
const sessionId = ref('')
const entryTime = ref(0)
const durationSent = ref(false)

function handleTabClick(tab) {
  console.log('完整的tab对象:', tab);
  console.log('tab.name:', tab.name);
  console.log('tab类型:', typeof tab);

  // 兼容不同的Element Plus版本
  const tabName = tab.name || tab.paneName || (tab.props && tab.props.name);
  console.log('解析出的tabName:', tabName);

  if (tabName === 'sol') {
    console.log('触发sol跳转');
    scrollToSection('our-solutions');
  }
  else if (tabName === 'pro') {
    console.log('触发pro跳转');
    scrollToSection('products');
  }
  else if (tabName === 'producthard') {
    console.log('触发producthard跳转');
    scrollToSection('producthard');
  }
  else if (tabName === 'case') {
    console.log('触发case跳转');
    scrollToSection('success');
  }
  else if (tabName === 'news') {
    console.log('触发news跳转');
    scrollToSection('news');
  }
  else {
    console.log('未匹配到任何tab名称');
  }
}
function scrollToSection(sectionId) {
  const element = document.getElementById(sectionId);
  if (element) {
    // 动态获取导航栏实际高度
    const navBar = document.querySelector('.nav-bar');
    const navHeight = navBar ? navBar.offsetHeight : 80;

    // 动态获取Tab栏实际高度
    const tabBar = tabBarRef.value;
    const tabHeight = tabBar ? tabBar.offsetHeight : 60;

    // 根据Tab栏是否固定计算偏移量
    const offset = isTabFixed.value ? navHeight + tabHeight : navHeight;
    const elementPosition = element.offsetTop - offset;

    // 调试信息
    console.log('=== scrollToSection 调试信息 ===');
    console.log('目标元素ID:', sectionId);
    console.log('元素原始位置 (offsetTop):', element.offsetTop);
    console.log('导航栏实际高度:', navHeight);
    console.log('Tab栏实际高度:', tabHeight);
    console.log('Tab栏是否固定 (isTabFixed):', isTabFixed.value);
    console.log('计算的偏移量 (offset):', offset);
    console.log('最终滚动位置 (elementPosition):', elementPosition);
    console.log('当前滚动位置:', window.pageYOffset || document.documentElement.scrollTop);
    console.log('================================');

    window.scrollTo({
      top: elementPosition,
      behavior: 'smooth'
    });
  } else {
    console.log('未找到目标元素:', sectionId);
  }
}

function goToContact(type) {
  console.log('goToContact被调用,参数:', type);
  emit('scroll-to-contact', type)
}
//页面缩小，适应布局
const isMobile = ref(false)
const checkMobile = () => {
  isMobile.value = window.innerWidth <= 1024
  console.log(isMobile.value); // 打印 isMobile.value
}

// 处理滚动事件
const handleScroll = () => {
  if (!tabBarRef.value) return

  const scrollTop = window.pageYOffset || document.documentElement.scrollTop
  const navHeight = 80 // 导航栏高度

  // 当滚动位置超过Tab栏原始位置减去导航栏高度时，固定Tab栏
  isTabFixed.value = scrollTop >= (tabBarOriginalTop.value - navHeight)

  // ScrollSpy：根据滚动位置切换 activeTab
  const tabHeight = tabBarRef.value ? tabBarRef.value.offsetHeight : 60
  const offset = isTabFixed.value ? navHeight + tabHeight : navHeight

  let current = activeTab.value
  for (const { id, tab } of orderedSectionToTab.value) {
    const el = document.getElementById(id)
    if (!el) continue
    const top = el.offsetTop - offset
    if (scrollTop >= top - 10) {
      current = tab
    }
  }

  // 到达页面底部，确保选中最后一个 Tab
  if ((window.innerHeight + scrollTop) >= (document.documentElement.scrollHeight - 2)) {
    current = 'news'
  }

  if (current !== activeTab.value) {
    activeTab.value = current
  }
}

function goto_system(id) {
  if (window.location.pathname.startsWith('/en')) {
    router.push(`/en/productdetail?id=${id}`)
  } else {
    router.push(`/productdetail?id=${id}`)
  }
}
function goto_device(id) {
  if (window.location.pathname.startsWith('/en')) {
    router.push(`/en/productharddetail?id=${id}`)
  } else {
    router.push(`/productharddetail?id=${id}`)
  }
}
function goto_news() {
  if (window.location.pathname.startsWith('/en')) {
    router.push('/en/news')
  } else {
    router.push('/news')
  }
}
function goto_methods(id) {
  if (window.location.pathname.startsWith('/en')) {
    router.push(`/en/solutiondetail?id=${id}`)
  } else {
    router.push(`/solutiondetail?id=${id}`)
  }
}
function goto_case(id) {
  if (window.location.pathname.startsWith('/en')) {
    router.push(`/en/casedetail?id=${id}`)
  } else {
    router.push(`/casedetail?id=${id}`)
  }
}
function goto_newdetail(id) {
  if (window.location.pathname.startsWith('/en')) {
    router.push(`/en/newsdetail?id=${id}`)
  } else {
    router.push(`/newsdetail?id=${id}`)
  }
}
function isbutton(index) {
  isshowbutton.value[index] = true
}
function unbutton(index) {
  isshowbutton.value[index] = false
}
function isbuttonpPro(index) {
  isshowbuttonPro.value[index] = true
}
function unbuttonpPro(index) {
  isshowbuttonPro.value[index] = false
}

async function mainrender() {
  const appId = window.location.pathname.startsWith('/en') ? 2 : 1

  datalist.value = []
  pro_data.value = []
  pro_data2.value = []
  isshowbuttonPro.value = []
  suc_data.value = []
  new_data.value = []

  const sul_res = await getSolutionList({ appId, current: 1, size: 100 })
  datalist.value = sul_res.data || []

  const pro_res = await getProductList({ appId, current: 1, size: 100 })
  pro_data.value = pro_res.data || []

  const hard_res = await getDeviceTypeList({ appId, current: 1, size: 100 })
  pro_data2.value = hard_res.data || []
  const deviceTypes = hard_res.data || []
  if (deviceTypes.length) {
    const devicePromises = deviceTypes.map(type =>
      getDeviceList({ appId, deviceTypeId: type.id, current: 1, size: 100 })
    )
    const deviceResults = await Promise.all(devicePromises)
    hardwareGroupData.value = deviceTypes
      .map((type, i) => ({
        typeId: type.id,
        typeName: type.name,
        devices: (deviceResults[i] && deviceResults[i].data) ? deviceResults[i].data : []
      }))
      .filter(group => group.devices.length > 0)
  } else {
    hardwareGroupData.value = []
  }

  const suc_res = await getCaseList({ appId, current: 1, size: 100 })
  suc_data.value = (suc_res.data || []).slice(0, 3)

  const new_res = await getNewsList({ appId, current: 1, size: 100 })
  const newsRecords = (new_res.data || []).slice()
  newsRecords.sort((a, b) => (b.top || 0) - (a.top || 0))
  new_data.value = newsRecords
  first_data.value = newsRecords[0]
}
function splitDate(dateStr) {
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) {
    return null;
  }
  return {
    year: date.getFullYear(),
    month: String(date.getMonth() + 1).padStart(2, '0'),
    day: String(date.getDate()).padStart(2, '0')
  };
}

function parseUserAgent() {
  const ua = navigator.userAgent
  const result = { os: '', browser: '', deviceType: '' }

  if (/Windows/i.test(ua)) result.os = 'Windows'
  else if (/Mac/i.test(ua)) result.os = 'MacOS'
  else if (/iPhone|iPad|iOS/i.test(ua)) result.os = 'iOS'
  else if (/Android/i.test(ua)) result.os = 'Android'
  else if (/Linux/i.test(ua)) result.os = 'Linux'
  else result.os = 'Unknown'

  if (/Edg/i.test(ua)) result.browser = 'Edge'
  else if (/Chrome/i.test(ua) && !/Edg/i.test(ua)) result.browser = 'Chrome'
  else if (/Safari/i.test(ua) && !/Chrome/i.test(ua) && !/Edg/i.test(ua)) result.browser = 'Safari'
  else if (/Firefox/i.test(ua)) result.browser = 'Firefox'
  else result.browser = 'Unknown'

  if (/Mobile|Android|iPhone/i.test(ua)) result.deviceType = 'Mobile'
  else if (/iPad|Tablet/i.test(ua)) result.deviceType = 'Tablet'
  else result.deviceType = 'Desktop'

  return result
}

function generateSessionId() {
  return Date.now().toString(36) + '-' + Math.random().toString(36).substring(2, 10)
}

async function recordVisit() {
  sessionId.value = generateSessionId()
  entryTime.value = Date.now()

  const deviceInfo = parseUserAgent()
  const data = {
    deviceModel: navigator.userAgent,
    deviceOs: deviceInfo.os,
    deviceBrowser: deviceInfo.browser,
    deviceType: deviceInfo.deviceType,
    visitTime: new Date().toISOString(),
    pageUrl: window.location.href,
    referrer: document.referrer || '',
    language: navigator.language || '',
    sessionId: sessionId.value
  }

  try {
    await new Promise((resolve) => {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          data.latitude = pos.coords.latitude
          data.longitude = pos.coords.longitude
          resolve()
        },
        () => resolve()
      )
    })
  } catch {
    // geolocation not supported
  }

  try {
    await recordVisitor(data)
  } catch {
    // silently fail, don't block page rendering
  }
}

async function fetchSectionOrder() {
  const appId = window.location.pathname.startsWith('/en') ? 2 : 1
  const isEn = appId === 2
  const nameToTab = {
    '我们的解决方案': { name: 'sol', label: '我们的解决方案', sectionKey: 'solution' },
    'Our Solutions': { name: 'sol', label: 'Our Solutions', sectionKey: 'solution' },
    '软件产品': { name: 'pro', label: '产品软件', sectionKey: 'product' },
    'Software Products': { name: 'pro', label: 'Software', sectionKey: 'product' },
    '硬件产品': { name: 'producthard', label: '硬件产品', sectionKey: 'productHard' },
    'Hardware Products': { name: 'producthard', label: 'Hardware', sectionKey: 'productHard' },
    '成功案例': { name: 'case', label: '成功案例', sectionKey: 'case' },
    'Success Cases': { name: 'case', label: 'Success Cases', sectionKey: 'case' },
    '新闻': { name: 'news', label: '新闻', sectionKey: 'new' },
    'News': { name: 'news', label: 'News', sectionKey: 'new' },
  }
  const hideInEnKeys = new Set(['硬件产品', 'Hardware Products'])

  try {
    const res = await getHomeSectionOrder({ appId })
    if (res.code === 200 && res.data && res.data.length) {
      // 选项卡：直接从后端返回的顺序构建
      orderedTabs.value = res.data
        .map(item => nameToTab[item.name])
        .filter(tab => tab && !(isEn && hideInEnKeys.has(tab.label)))

      // 默认选中第一个选项卡
      if (orderedTabs.value.length) {
        activeTab.value = orderedTabs.value[0].name
      }

      // sectionOrder：用于区块 CSS order 排序
      const map = {}
      res.data.forEach((item, index) => {
        const tab = nameToTab[item.name]
        if (tab) {
          map[tab.sectionKey] = index + 1
        }
      })
      sectionOrder.value = map
    } else {
      setDefaultOrder(isEn)
    }
  } catch {
    setDefaultOrder(isEn)
  }
}

function setDefaultOrder(isEn) {
  sectionOrder.value = {
    solution: 1,
    product: 2,
    productHard: 3,
    case: 4,
    new: 5
  }
  orderedTabs.value = isEn
    ? [
        { name: 'sol', label: 'Our Solutions' },
        { name: 'pro', label: 'Software' },
        { name: 'case', label: 'Success Cases' },
        { name: 'news', label: 'News' },
      ]
    : [
        { name: 'sol', label: '我们的解决方案' },
        { name: 'pro', label: '产品软件' },
        { name: 'producthard', label: '硬件产品' },
        { name: 'case', label: '成功案例' },
        { name: 'news', label: '新闻' },
      ]
  if (orderedTabs.value.length) {
    activeTab.value = orderedTabs.value[0].name
  }
}

function getStayDuration() {
  if (!entryTime.value) return 0
  return Math.floor((Date.now() - entryTime.value) / 1000)
}

async function sendStayDuration() {
  if (durationSent.value || !sessionId.value) return
  durationSent.value = true
  const duration = getStayDuration()
  if (duration <= 0) return
  try {
    await updateVisitorDuration({ sessionId: sessionId.value, duration })
  } catch {
    // silently fail
  }
}

function handleBeforeUnload() {
  if (durationSent.value || !sessionId.value) return
  const duration = getStayDuration()
  if (duration <= 0) return
  durationSent.value = true
  const data = JSON.stringify({ sessionId: sessionId.value, duration })
  navigator.sendBeacon(
    'http://192.168.8.81:13000/officialVisitorLog/updateDuration',
    new Blob([data], { type: 'application/json' })
  )
}

</script>

<style scoped>
/* 轮播图 */
.demonstration {
  color: var(--el-text-color-secondary);
}

.el-carousel__item h3 {
  color: #475669;
  opacity: 0.75;
  line-height: 25em;
  margin: 0;
  text-align: center;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

/* 轮播图定义按钮 */
.demo,
.contact {
  width: 10em;
  height: 3em;
  border-radius: 1.5em;
  font-size: 1em;
  border: transparent;
  cursor: pointer;
  margin: 0.5em auto;
}

.title {
  text-align: center;
  width: 65%;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0 auto;
  color: white;
}

.demo {
  background-color: orange;
  color: white;
  margin-right: 1em;
}

.contact {
  background-color: skyblue;
  color: white;
}

/* 箭头 */
:deep(.el-carousel__arrow) {
  display: none !important;
}

.el-carousel {
  position: relative;
}

.b-hight {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 11em;
  background-image: url('https://offcial-web-static.oss-cn-beijing.aliyuncs.com/shouyebanner.png');
  width: 100%;
  background-size: cover;
  background-position: center;
  text-align: center;
  background-repeat: no-repeat;
}

.b-hight .el-icon {
  color: white !important;
  font-size: 35px;
}

.b-hight .left,
.b-hight .right {
  position: absolute;
  background-color: transparent;
  border-color: transparent;
  top: 17em;
}

.b-hight .left {
  left: 1em;
}

.b-hight .right {
  right: 1em;
}

/* 展示框 */
/*our solution*/
.grid-content .fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.grid-content .fade-enter-from,
.fade-leave-to {
  display: none;
}

.grid-box {
  position: relative;
  width: 100%;
  height: 100%;
}

.grid-box>img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.grid-box .box-content {
  position: absolute;
  width: 80%;
  height: 100%;
  top: 2em;
  left: 2em;
  transition: transform 0.3s ease;
  transform: translateY(0);
}

.grid-box .box-content:hover {
  transform: translateY(-10px);
}

.grid-box .box-content h3,
.grid-box .box-content p,
.grid-box .box-content .el-button {
  color: white;
  margin-bottom: 2em;
}

.right-content {
  transition: transform 0.3s ease;
  transform: translateY(0);
}

.right-content:hover {
  transform: translateY(-10px);
}

/* products */
.fro-hid .grid-content .fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fro-hid .grid-content .fade-enter-from,
.fade-leave-to {
  display: none;
}

.fro-hid .el-fro {
  transition: transform 0.3s ease;
  transform: translateY(0);
}

.fro-hid .el-fro:hover {
  transform: translateY(-10px);
}

.box-content p,
.right-content p {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.box-content .el-button {
  background-color: transparent;
}

.grid-all {
  display: flex;
}

.grid-all .grid-left,
.grid-all {
  width: 50%;
  height: 100%;
}

.grid-right {
  width: 60%;
  height: 100%;
}

.grid-all .grid-left img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.grid-all .grid-right .right-content {
  width: 80%;
  height: 100%;
  margin: 2em auto;
}

.grid-all .grid-right .right-content h3,
.grid-all .grid-right .right-content p,
.grid-all .grid-right .right-content .el-button {
  margin-bottom: 2em;
}

.grid-all .grid-right .right-content .el-button {
  background-color: transparent;
}

/* title */
.our-dis>h1,
.fro-dis>h1,
.suc-dis>h1,
.news-dis>h1 {
  width: 100%;
  text-align: center;
  margin-top: 1em;
}

.our-dis>p,
.fro-dis>p,
.suc-dis>p,
.news-dis>p {
  width: 40%;
  text-align: center;
  margin: 1em auto;
}

.section-wrapper {
  display: flex;
  flex-direction: column;
  background-image: url('https://offcial-web-static.oss-cn-beijing.aliyuncs.com/shiuyebeijing.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
}

.our-dis,
.fro-dis,
.adv-dis,
.suc-dis,
.news-dis,
.link-dis {
  width: 60%;
  margin: 1em auto;
}

.bo-le:hover {
  color: #FF6B02;
}

.bo-le,
.ri-le {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  /* 限制显示2行 */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ri-le:hover {
  color: #FF6B02;
}

.ri-le {
  width: 30em;
  margin-right: 2em;
}

.ri-ri {
  width: 10em;
  margin-left: 2em;
}

.news-dis .news-main {
  width: 100%;
  margin: 3em auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
}

.news-dis .news-main .news-left,
.news-dis .news-main .news-right {
  width: 48%;
  height: 25em;
}

.news-dis .news-main .news-left {
  color: #323232;
  box-shadow: 0px 0px 6px 0px #ddd;
}

.news-dis .news-main .news-left img {
  width: 100%;
  height: 60%;
  object-fit: cover;
}

.news-dis .news-main .news-left .left-con {
  width: 90%;
  /* height: 40%; */
  margin: 0 auto;
}

.news-dis .news-main .news-left .left-con>p {
  color: #6C6C6C;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  /* 限制显示2行 */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 1em auto;
}

.news-dis .news-main .news-left .left-con .bo-time {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 1.1em;
  width: 100%;
}

.news-dis .news-main .news-left .left-con .bo-time .bo-le,
.news-dis .news-main .news-left .left-con .bo-time .bo-ri {
  width: 45%;
}

.news-dis .news-main .news-left .left-con .bo-time .bo-mi {
  color: #ddd;
}

.news-dis .news-main .news-left .left-con .bo-time .bo-ri {
  padding-left: 2em;
}

.news-dis .news-main .news-right>ul li {
  list-style: none;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 1em;
  border-bottom: 1px solid #ddd;
}

.new-btn {
  margin-top: 1em;
  width: 8em;
  height: 3em;
  background-color: transparent;
  border: 1px solid #323232;
  cursor: pointer;
}

.news-dis .news-main .news-right ul li {
  border-bottom: 1px dashed #ddd;
  color: #323232;
}

.news-dis .news-main .news-right ul li>p {
  width: 100%;
  display: -webkit-box;
  color: #6C6C6C;
  -webkit-line-clamp: 1;
  /* 限制显示2行 */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  /* margin: 1em auto; */
  margin-bottom: 1em;
}

.news-dis .news-main .news-right ul li .ri-con {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 1.1em;
  width: 100%;
  margin-bottom: 1em;
}

/* 分隔栏展示 */
.split-dis {
  width: 100%;
  height: 10em;
  background-color: rgb(53, 59, 68);
}

.split-dis ul {
  width: 60%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;
}

.split-dis li {
  list-style: none;
  flex-direction: column;
  align-items: center;
  text-align: center;
  color: white;
}

.split-dis ul li>img {
  width: 5em;
  height: 5em;
}

.el-hid,
.fro-hid,
.suc-hid {
  width: 100%;
  overflow: hidden;
  margin: 0 auto;
}

.fro-hid>h3 {
  width: 100%;
}

/* 硬件产品分组展示 */
.hardware-type-group {
  margin-bottom: 2em;
}

.hardware-type-name {
  font-size: 1.1em;
  font-weight: 600;
  color: #323232;
  margin-bottom: 1em;
  padding-left: 0.5em;
  border-left: 3px solid #005BAC;
}

.hardware-item {
  text-align: center;
  cursor: pointer;
  margin-bottom: 1.5em;
  transition: transform 0.3s ease;
}

.hardware-item:hover {
  transform: translateY(-4px);
}

.hardware-item img {
  width: 100%;
  height: 10em;
  object-fit: contain;
  margin-bottom: 0.5em;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
}

.hardware-item-name {
  display: block;
  font-size: 0.9em;
  color: #323232;
  font-weight: 500;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 移动端硬件网格 */
.hardware-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.8em;
}

.hardware-grid .hardware-item img {
  height: 7em;
}

.hardware-grid .hardware-item-name {
  font-size: 0.75em;
}

.adv-hid {
  width: 100%;
  overflow: hidden;
  margin: 2em auto;
}

.new-hid {
  width: 80%;
  overflow: hidden;
  margin: 5em auto;
}

.el-empty {
  width: 100%;
  height: 100%;
}

.el-col {
  height: 6%;
}

.el-col .grid-content,
.grid-content1 {
  width: 100%;
  height: 20em;
}

.grid-content img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.grid-content1 img {
  width: 100%;
  height: 45%;
  object-fit: cover;
}

.grid-content1 .grid-main {
  width: 80%;
  height: 55%;
  overflow: hidden;
  margin: 0 auto;

}

.grid-content1 .grid-main>p {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  /* 限制显示3行 */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 3em !important;
}

.grid-content1 .grid-main>h3 {
  display: flex;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  /* 限制显示3行 */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-emphasis: none;
  flex-wrap: wrap;
  align-items: flex-end;
  margin: 1em auto;
}

.grid-content1 .grid-main .grid-btn {
  margin-top: .6em;
  height: 3em;
  width: 6em;
  background-color: transparent;
  cursor: pointer;
}

.col-fro {
  position: relative;
  margin-bottom: 2em;
}

.el-fro {
  color: white;
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  bottom: 10%;
  left: 6%;
}

.el-fro2>h3 {
  color: white;
  position: absolute;
  font-size: 25px;
  top: 80%;
  left: 6%;
}

.el-fro>h3 {
  font-size: 25px;
  margin-bottom: 0.5em;
}

.el-fro>p {
  width: 75%;
  font-size: 18px;
  margin-bottom: 1em;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
}

.el-fro .pro-plat {
  height: 2.5em;
  width: 5em;
  color: white;
  background-color: transparent;
  border: 1px solid white;
  border-radius: 0.3em;
  cursor: pointer;
}

.posit-btn {
  position: relative;
}

.link-btn {
  width: 100px;
  height: 30px;
  position: absolute;
  top: 85px;
  right: 50px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background-color: rgb(0, 200, 202);
}

.link-btn span {
  padding-left: 5px;
}

/* 移动端响应媒体 */
@media (max-width: 1024px) {

  .our-dis>h1,
  .fro-dis>h1,
  .adv-dis>h1,
  .suc-dis>h1,
  .news-dis>h1,
  .link-dis>h1 {
    font-size: 1.2em;
  }

  .our-dis>p,
  .fro-dis>p,
  .adv-dis>p,
  .suc-dis>p,
  .news-dis>p,
  .link-dis>p {
    font-size: 0.8em;
  }

  .banner {
    background-image: url('https://official-web-static.womucloud.com/bigBanner/m/home.jpg');
  }

  .b-hight {
    height: 11em;
    gap: 0.8em;
  }

  .our-dis,
  .fro-dis,
  .adv-dis,
  .suc-dis,
  .news-dis,
  .link-dis {
    width: 90%;
    margin: 0.1em auto;
  }

  .news-dis .news-grid-container {
    width: 100%;
  }

  .title {
    font-size: 1.2em;
  }

  .demo,
  .contact {
    font-size: 0.8em;
    height: 2.5em;
  }

  .fro-hid .el-row .col-fro {
    margin-bottom: 2em;
    width: 100%;
  }

  .news-dis .news-grid-container {
    width: 90%;
    margin: 0 auto;
  }

  .grid-box .box-content:hover {
    transform: translateY(0);
  }

  .right-content:hover {
    transform: translateY(0);
  }

  .fro-hid .el-fro:hover {
    transform: translateY(0);
  }

  /* 移动端解决方案：左右布局改为上下堆叠 */
  .grid-all {
    flex-direction: column;
  }

  .grid-all .grid-left,
  .grid-all .grid-right {
    width: 100%;
    height: 50%;
  }

  .el-hidmobile .el-col {
    margin-bottom: 1.5em;
  }

  .grid-box .box-content h3,
  .grid-box .box-content p {
    margin-bottom: 0.8em;
  }

  .grid-all .grid-right .right-content h3,
  .grid-all .grid-right .right-content p {
    margin-bottom: 0.8em;
  }

  .box-content>h3 {
    font-size: 1em;
  }

  .box-content>p {
    font-size: 0.8em;
  }

  .right-content>h3 {
    font-size: 1em;
  }

  .right-content>p {
    font-size: 0.8em;
  }

  .el-fro>h3 {
    font-size: 1.2em;
  }

  .el-fro>p {
    font-size: 0.8em;
  }

  /* 栅格布局样式 */
  .news-grid-container {
    width: 100%;
    margin-top: 1em;
    padding: 0 1em;
  }

  .news-grid {
    display: grid;
    grid-template-columns: 1fr;
    /* 单列布局 */
    gap: 1.5em;
    /* 项目间距 */
  }

  .news-item {
    width: 100%;
    display: grid;
    grid-template-rows: auto auto;
    /* 两行布局：描述和元数据 */
    gap: 0.5em;
    padding: 1em;
    background: #fff;
    cursor: pointer;
    border-bottom: 1px dashed #BEBEBE;
  }

  .news-description {
    width: 100%;
    margin: 0;
    font-size: 0.8em;
    line-height: 1.4;
    display: -webkit-box;
    color: #6C6C6C;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    ;
    text-overflow: ellipsis;
  }

  .news-meta {
    width: 100%;
    display: flex;
    grid-template-columns: auto auto auto;
    gap: 0.5em;
    align-items: center;
    font-size: 1em;
    color: #323232;
  }

  .news-meta .news-author {

    width: 60%;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .news-separator {
    width: 1em;
    opacity: 0.5;
  }

  .news-time {
    width: 40%;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .news-more {
    display: grid;
    place-items: center;
    padding: 1em;
  }

  .news-btn {
    padding: 0.8em 2em;
    cursor: pointer;
    background-color: transparent;
    border: 1px solid #000;
    color: #323232;
  }

  .split-dis ul {
    width: 90%;
  }

  .split-dis ul li>span {
    font-size: 0.5em;
  }

  .split-dis ul li>img {
    width: 2em;
    height: 2em;
  }

  .el-col .grid-content,
  .grid-content1 {
    width: 100%;
    height: 16em;
  }

  .box-content p,
  .right-content p {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .suc-dis>p {
    width: 80%;
  }

  .mobile-tab-bar {
    position: relative;
    width: 100% !important;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 1em auto;
    background: #fff;
    z-index: 100;
    box-sizing: border-box;
    overflow: hidden;
    /* transition: all 0.3s ease; */
  }

  .mobile-tab-bar.is-fixed {
    position: fixed;
    top: 60px;
    /* 导航栏高度 */
    left: 50%;
    transform: translateX(-50%);
    /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15); */
    /* border-radius: 8px; */
    padding: 8px 0;
  }

  .mobile-tab-bar .el-tabs {
    width: auto;
    max-width: 100%;
    margin: 0 auto;
    overflow-x: auto;
  }

  .mobile-tab-bar .el-tabs__nav {
    display: flex;
    min-width: max-content;
    justify-content: center;
    margin: 0 auto;
    overflow-x: auto;
    scrollbar-width: thin;
    scrollbar-color: #ccc #fff;
  }

  .mobile-tab-bar .el-tabs__item {
    flex: 0 0 auto;
    min-width: 80px;
    text-align: center;
    white-space: nowrap;
    font-size: 15px;
    padding: 0 8px;
  }

  .mobile-tab-bar .el-tabs__nav::-webkit-scrollbar {
    height: 4px;
  }

  .mobile-tab-bar .el-tabs__nav::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 2px;
  }

  /* .mobile-tab-bar >>> .el-tabs__nav-prev ,
.mobile-tab-bar >>> .el-tabs__nav-next {
  display: none !important;
} */
  /* 为固定状态下的Tab栏添加占位空间，防止内容跳动 */
  .mobile-tab-bar.is-fixed+* {
    margin-top: 60px;
    /* Tab栏高度的占位 */
  }
}
</style>